import OAWFTrackVer from './src/track.vue';
/* istanbul ignore next */
OAWFTrackVer.install = function(Vue) {
  Vue.component('oa-wf-track-ver', OAWFTrackVer);
};
export default OAWFTrackVer;


// WEBPACK FOOTER //
// ./src/components/oa/view/official/cmps/track/track_ver/index.js